/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Extract_ActionInputs */



/**
* | output |
* | --- |
* | "Extract" |
*
* @param {Subtitle_Extract_ActionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_extract_action = /** @type {((inputs?: Subtitle_Extract_ActionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Extract_ActionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Extrait")
	if (locale === "de") return /** @type {LocalizedString} */ ("Extrakt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Estrarre")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Извлекать")
	if (locale === "es") return /** @type {LocalizedString} */ ("Extracto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("提炼")
	if (locale === "ja") return /** @type {LocalizedString} */ ("抽出する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("निकालना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Extrair")
	return /** @type {LocalizedString} */ ("Extract")
});